export const PRODUCT_DESCRIPTION_VISIBILITY_NAME = 'productDescription';

export interface ProductDescriptionImpression {
  event: 'custom_event';
  event_category: 'Product long description';
  event_action: 'Impression';
  event_label: 'not set';
}

export interface ProductDescriptionToggleExpand {
  event: 'custom_event';
  event_action: 'Show more';
  event_category: 'Product long description';
  event_label: 'not set';
}
